// Keep the namespace centralized in one TypeGen-friendly file.
// Sanity TypeGen cannot statically evaluate imported helpers or env-expression chains here.
export const NEXT_PUBLIC_NAMESPACE = 'portaNZ';

export const namespaceType = (typeName: string) => `${NEXT_PUBLIC_NAMESPACE}.${typeName}`;

export const namespaceDocumentId = (documentId: string) => `${NEXT_PUBLIC_NAMESPACE}.${documentId}`;
